import type { TaxonomyFieldTemplate } from '@/entities/taxonomy-field-template';
import { STANDARD_FIELD_LIBRARY } from '../../TaxonomyDetail/components/FieldLibraryModal/standard-fields';

/**
 * The standard-fields catalog entry a template came from, or null for a
 * hand-made field.
 *
 * Falls back to a name+category match so rows seeded before `libraryKey`
 * existed still resolve — the same pairing the backend dedupes on. Editing such
 * a row backfills its key, after which the match survives a rename.
 */
export function standardKeyOf(template: TaxonomyFieldTemplate): string | null {
  if (template.libraryKey) return template.libraryKey;
  const name = template.name.trim().toLowerCase();
  const category = template.category.trim().toLowerCase();
  return (
    STANDARD_FIELD_LIBRARY.find(
      (f) => f.name.toLowerCase() === name && f.category.toLowerCase() === category,
    )?.key ?? null
  );
}
